import { IEventModule } from "@Modules/eventPage/root/IEventModule";
import { DOMAttributes, useRef, useState } from "react";
import { IPlanOverhang } from "./IPlanOverhang";

export const usePlanOverhangContainer = ({
    urlQueryParams,
}: {
    urlQueryParams: IEventModule.IProps["urlQueryParams"];
}) => {
    const planDropdownRef = useRef<HTMLDivElement>(null);
    const [showPlanOverhang, setShowPlanOverhang] = useState<boolean>(false);

    const handlePlanOverhangContainerScroll: DOMAttributes<HTMLDivElement>["onScroll"] =
        e => {
            const planDropdownOffsetTop = planDropdownRef?.current?.offsetTop;
            const containerScrollTop = (e?.target as HTMLDivElement)?.scrollTop;
            if (containerScrollTop && planDropdownOffsetTop) {
                setShowPlanOverhang(containerScrollTop > planDropdownOffsetTop);
            }
        };

    const planOverhangProps: IPlanOverhang.IProps = {
        planDropdownRef,
        urlQueryParams,
    };

    return {
        planDropdownRef,
        handlePlanOverhangContainerScroll,
        planOverhangProps,
        showPlanOverhang,
    };
};
